import angular from 'angular';
import secureAeriesConnectionComponent from './secureAeriesConnection.component';

let secureAeriesConnectionModule = angular.module('secureAeriesConnection', []).component('secureAeriesConnection', secureAeriesConnectionComponent);

export default secureAeriesConnectionModule;



// WEBPACK FOOTER //
// ./app/components/secureAeriesConnection/secureAeriesConnection.js